import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useOs } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { useInstallNotification } from '../hooks/useInstallNotification';

export const InstallNotification = observer(() => {
  const { t } = useTranslation('install-banner');
  const operatingSystem = useOs();
  const { showInstallNotification, handleClose } = useInstallNotification();

  return (
    <div
      className={classNames(
        'no-scrollbar fixed bottom-0 left-0 right-0 flex h-full w-full flex-col items-center overflow-auto pt-[200px] transition-transform duration-[2000ms] sm:hidden',
        {
          'visible z-50 translate-y-0 opacity-100': showInstallNotification,
          'invisible -z-[10] translate-y-[50%] opacity-0':
            !showInstallNotification,
        },
      )}
    >
      <div className="flex-1"></div>
      <div className="rounded-t-xl bg-brand-1 p-5 flex-1 w-full">
        <div className="flex w-full justify-end">
          <span
            onClick={handleClose}
            className="icon icon-close text-xl text-white"
          />
        </div>

        <img
          className="my-5 h-[200px] w-auto"
          src={`dist/public/assets/images/notification-${operatingSystem}.png`}
          alt="Notification"
        />
        <span className="my-5 block text-center text-lg text-white">
          {t(`install-banner:${operatingSystem}-description`)}
        </span>

        <div className="my-5 flex">
          <div className="flex flex-1 flex-col items-center">
            <img
              className="h-8 w-8 text-brand-2"
              src={`dist/public/assets/icons/icon-${operatingSystem}-menu.svg`}
              alt="Download Icon"
            />

            <span className="mt-2 block text-center text-base text-white">
              {t(`install-banner:${operatingSystem}-icon-menu`)}
            </span>
          </div>

          <span className="icon icon-plus mx-3 mt-[10px] block text-xl text-white" />

          <div className="flex flex-1 flex-col items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-md border-[3px] border-brand-2">
              <span className="icon icon-plus text-lg font-semibold text-brand-2" />
            </div>
            <span className="mt-2 block text-center text-base text-white">
              {t(`install-banner:${operatingSystem}-icon-add`)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});
